<template src="./html/TopWidget.html"></template>

<script>
	export default {
		props: ['user', 'isAuth', 'refresh'],
		data () {
			return {
				total_tasks: null,
				completed_tasks: null,
				statuses: null,
			}
		},
		created () {
			this.init()
		},
		watch: {
			'$i18n.locale'() {
				this.reload();
			}
		},
		computed: {
			percentageCompletedTasks: function() {
				return this.completed_tasks * 100 / this.total_tasks
			},
		},
		methods: {
			init() {
				this.getData()
			},
			reload() {
				this.getData()
			},
			percentage(tasks) {
				return tasks * 100 / this.total_tasks
			},
			reload() {
				this.getData()
			},
			getData: function() {
				this.$http.get('admin/projects/tasks/statuses/get')
					.then(response => {
						this.total_tasks = response.body.total_tasks
						this.completed_tasks = response.body.completed_tasks
						this.statuses = response.body.statuses
					})
			}
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/projects/dashboard/views/TopWidget.vue